import Lottie from "lottie-react";
import { ArrowUpRight } from "lucide-react";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import cogsAnimation from "src/assets/COGS_anim.json";
import imageVid from "src/assets/img/imageVid.png";
import { useSectionStore } from "src/store/croModule.state";
import { useMarketStore } from "src/store/market.state";
import { ActiveStepStore } from "src/store/onboarding.store";
import LightBulb from "../../assets/icons/Lightbulb.svg";
import { stepConfig } from "./config";
import styles from "./styles.module.scss";

const LearningMaterials = ({
  activeStep,
  setModal,
}: {
  activeStep: number;
  setModal?: (open: boolean) => void;
}) => {
  const [visible, setVisible] = useState(true);
  const nav = useNavigate();

  const { setStep, subStepsCompleted, markSubStepComplete } = ActiveStepStore();
  const { isWhatIf, changeWhatIf } = useSectionStore();
  const { setIsWhatIf } = useMarketStore();
  const [subStepIndex, setSubStepIndex] = useState(
    subStepsCompleted[activeStep]?.findIndex((item) => item === false) || -1,
  );

  const config = stepConfig[activeStep];
  const stepItems = config.getStepItems?.() || [];
  const [buttonLabel, setButtonLabel] = useState<string>("CONTINUE");

  useEffect(() => {
    setVisible(true);
  }, [activeStep]);

  const handleConnectAccount = () => {
    nav("/connect-seller-account");
  };

  const handleMarketIntelligence = () => {
    if (!subStepsCompleted[3][0]) {
      markSubStepComplete(3, 0);
    } else if (subStepsCompleted[3][0] && !subStepsCompleted[3][1]) {
      setIsWhatIf(true);
      changeWhatIf(!isWhatIf);
      markSubStepComplete(3, 1);
    } else {
      setStep(4);
    }
  };

  const handleAction = () => {
    const items = stepItems;
    const lastIndex = items.length - 1;

    if (subStepIndex < lastIndex) {
      setSubStepIndex((prev) => prev + 1);
    }

    switch (activeStep) {
      case 0:
        setStep(1);
        break;
      case 1:
        handleConnectAccount();
        break;
      case 2:
        setModal?.(true);
        break;
      case 3:
        console.log(3);
        handleMarketIntelligence();
        break;
      case 4:
        nav("/canvas", { state: {} });
        setStep(5);
        break;
      default:
        console.warn(`Unhandled step: ${activeStep}`);
        break;
    }
  };

  useEffect(() => {
    if (activeStep === 3) {
      if (subStepIndex === 0) {
        setButtonLabel("CHECK MI");
      } else if (subStepIndex === 1) {
        setButtonLabel("SWITCH TO WHAT IF");
      }
    } else {
      setButtonLabel(config.buttonLabel);
    }
  }, [activeStep, subStepsCompleted]);

  if (!config) return null;

  return (
    <div className={styles.wrapper}>
      <button className={styles.toggle} onClick={() => setVisible(!visible)}>
        {!visible && (
          <>
            <img src={LightBulb} alt="LightBulb" height={16} width={16} />
            <span>SHOW LEARNING MATERIALS</span>
          </>
        )}
      </button>
      {visible && (
        <div className={styles.card}>
          {activeStep === 4 && (
            <button className={styles.canvasBtn} onClick={handleAction}>
              <ArrowUpRight size={14} />
              {buttonLabel}
            </button>
          )}

          <div className={styles.header}>
            <div className={styles.title}>
              <img src={LightBulb} alt="LightBulb" height={24} width={24} />
              <h3>
                {subStepIndex >= 0 && stepItems[subStepIndex]
                  ? stepItems[subStepIndex].title
                  : config.title}
              </h3>
            </div>

            {activeStep !== 4 && (
              <button className={styles.connectBtn} onClick={handleAction}>
                <ArrowUpRight size={14} />
                {buttonLabel}
              </button>
            )}
          </div>

          <div className={styles.cardWrapper}>
            <div className={styles.left}>
              <div className={styles.option}>
                <p className={styles.incomplete}>
                  {subStepIndex >= 0 && stepItems[subStepIndex]
                    ? stepItems[subStepIndex].description
                    : config.description}
                </p>
              </div>
              <button className={styles.ht} onClick={() => setVisible(false)}>
                HIDE LEARNING MATERIALS
              </button>
            </div>

            {activeStep === 2 && (
              <div className={styles.imageWrapper}>
                <Lottie animationData={cogsAnimation} loop autoplay />
              </div>
            )}
            {activeStep === 4 && (
              <div className={styles.imageWrapper}>
                <img src={imageVid} alt="Market Share Goal UI" />
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default LearningMaterials;
